<template>
  <span class="duration">
    <slot
      name="duration"
      :duration="formattedDuration"
    >
      {{ formattedDuration }}
    </slot>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    duration: {
      type: Number,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
    showPrefix: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    value () {
      return moment.duration(this.duration, 'minutes')
    },
    hours () {
      return this.value.days() * 24 + this.value.hours()
    },
    minutes () {
      return this.value.minutes()
    },
    hourSymbol () {
      return this.$t('hour_symbol')
    },
    minuteSymbol () {
      return this.$t('minute_symbol')
    },
    formattedDuration () {
      if (!this.duration && this.showEmpty) {
        return `0${this.hourSymbol}`
      }
      return (
        (this.hours ? `${this.hours}${this.hourSymbol} ` : '')
        + (this.minutes ? `${this.minutes}${this.minuteSymbol}` : '')
        + (this.showPrefix ? '+ ' : '')
      )
    },
  },
}
</script>
